var path = '/payments/payment/payment.html';
var html = "<md-card class=has-sidebar layout-wrap layout=column layout-gt-sm=row> <md-progress-linear md-mode=indeterminate ng-if=payment.$pending> </md-progress-linear> <article ng-include=\"'/payments/payment/_form.html'\" ng-if=!payment.$pending class=md-block layout-padding flex=100 flex-gt-sm=60> </article> <aside ng-include=\"'/payments/payment/_sidebar.html'\" class=\"payment-sidebar md-block\" ng-if=!payment.$pending layout-padding flex=100 flex-gt-sm=40> </aside> </md-card> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./payments/payment/payment.html
// module id = 280
// module chunks = 0